<script setup lang="ts">
import { ProjectListed } from "@/apps/page/project/sidebar/sections/tool/project-listed.interface";
import AddTool from "@/apps/page/project/sidebar/sections/tool/AddTool.vue";
import { useMutations, useState } from "@/store/vuex-composition-mappers";
import { computed, ref } from "vue";
import { PAGE_SECTION_KINDS } from "@/apps/page/services/page.service";
import { CardEmpty } from "@easy/ui/cards";
import { useSections } from "@/apps/page/services/useSections";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import { t } from "@/i18n";
import { projectsService } from "@/shared/projects/projects.service";
import { useRouter } from "vue-router";
import { setupDragStart } from "@/apps/page/project/sidebar/sections/dragOverlay";

const props = defineProps<{ projects: ProjectListed[]; tool: InPageUsedTools }>();
const emit = defineEmits(["dragStart"]);

const router = useRouter();
// @ts-expect-error
const { showModal } = useMutations(["showModal"]);
// @ts-expect-error (TODO: fix this)
const { page } = useState("page", ["page"]);
const { getSectionTypeByTool } = useSections();
const styleValues = computed(() => page.value.colors || {});

const toolRefs = ref<HTMLElement[]>([]);

const emptySection = computed(() => getSectionTypeByTool(props.tool));

async function handleDragStart(event: DragEvent, project: ProjectListed, index: number) {
    const toolElement = toolRefs.value[index];

    await setupDragStart(
        event,
        {
            type: PAGE_SECTION_KINDS.TOOL,
            data: project,
        },
        toolElement,
        {
            fallbackText: project.name,
        }
    );

    emit("dragStart");
}

function setToolRef(index: number, el: any) {
    if (el && el.$el) {
        toolRefs.value[index] = el.$el;
    } else if (el && el instanceof HTMLElement) {
        toolRefs.value[index] = el;
    }
}

function addNewProject() {
    const modalData = {
        type: "input",
        input: "",
        title: t("shared.list.name_project"),
        cancelBtn: t("shared.cancel"),
        actionBtn: t("shared.add"),
        callback: async () => {
            if (!modalData.input) {
                return;
            }
            const project = await projectsService.create({
                tool: props.tool,
                name: modalData.input,
            });
            // @ts-expect-error
            await router.push(`/${props.tool}/projects/${project?.uuid}?page=${page.value.uuid}`);
        },
    };
    showModal(modalData);
}
</script>

<template>
    <div class="p-3 mt-3">
        <div
            v-for="(project, index) of projects"
            :key="project.uuid"
            class="flex items-center flex-col gap-4 ct-ring-1 hover:ct-ring-brand cursor-move transition-all duration-200"
            draggable="true"
            :ref="(el) => setToolRef(index, el)"
            @dragstart="(e) => handleDragStart(e, project, index)"
        >
            <AddTool
                :project="project"
                :styleValues="styleValues"
                :fontFamily="page.fontFamily"
                :scrollAnimationType="page.settings?.scrollAnimationType"
            />
        </div>
        <CardEmpty
            v-if="projects.length === 0"
            :title="emptySection?.emptyTitle"
            :subtitle="emptySection?.emptySubtitle"
            :icon="emptySection?.icon"
            :cta-label="$t('shared.add')"
            @add="addNewProject"
        />
    </div>
</template>

<style scoped></style>
